// extracted by mini-css-extract-plugin
export default {"exceededWrapper":"SendTicketsPoolTiles_exceededWrapper__F86h+ punchupExceededRing","warningIcon":"SendTicketsPoolTiles_warningIcon__PsIpa"};